import { FC, PropsWithChildren } from "react";

const Title: FC<PropsWithChildren> = ({ children }) => (
  <div className="text-[18px] font-bold">
    {children}
  </div>
);

export default Title;
